import { useQuery } from '@tanstack/react-query';
import useLocaleQueryFilter from '../../utils/useLocaleQueryFilter';
import { AttributeValue } from './useAttributes';
import { ImageType, PriceType } from './useProducts';

export interface VariantsFilter {
  variantsIdList: number[];
}

export type VariantOrderItem = {
  variantId: number;
  productId: number;
  slug: string;
  label: string;
  externalReference: string;
  availableQuantity: number;
  localizedProductImage?: ImageType;
  defaultProductImage?: ImageType;
  localizedVariantImage?: ImageType;
  defaultVariantImage?: ImageType;
  attributes?: AttributeValue[];
  price: PriceType;
  priceOverwrite: PriceType;
};

export default function useVariantsByIds(filter: VariantsFilter) {
  const localeFilter = useLocaleQueryFilter(filter);

  return useQuery<VariantOrderItem[], Error>(['variants/byids', localeFilter], {
    enabled:
      filter.variantsIdList.length > 0 &&
      !!localeFilter.licenseId &&
      !!localeFilter.localeId,
    staleTime: 0,
  });
}
